<template>
  <div class="search-container">
    <Header></Header>
    <div class="search-container">
      <Search @sValue="sValue"></Search>
    </div>
    <div class="menu">
      <div class="menu-container">
        <nav-menu :lists="lists" :column="column" @sId="sId"></nav-menu>
      </div>
    </div>
    <div class="main-container">
      <div class="search-result">
        <span class="all-title">全部结果&nbsp;&nbsp;&gt;&nbsp;&nbsp;</span>
        <div class="display-area">
          <p v-if="searchValue" class="showValueSpan closed showValue margin0">
            <span class="w280">{{ searchValue }}</span>
            <svg
              @click="resetSearch(1)"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4152"
              width="14"
              height="14"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                d="M514.5 984.6c-63.8 0-125.8-12.5-184.1-37.2C274.1 923.6 223.5 889.5 180 846c-43.4-43.4-77.5-94-101.3-150.3C54 637.4 41.5 575.4 41.5 511.6S54 385.8 78.7 327.5c23.8-56.3 57.9-106.9 101.3-150.3 43.4-43.4 94-77.5 150.3-101.3 58.3-24.7 120.3-37.2 184.1-37.2s125.8 12.5 184.1 37.2c56.3 23.8 106.9 57.9 150.3 101.3 43.4 43.4 77.5 94 101.3 150.3 24.7 58.3 37.2 120.3 37.2 184.1s-12.5 125.8-37.2 184.1C926.4 752 892.3 802.6 848.9 846c-43.4 43.4-94 77.5-150.3 101.3-58.3 24.7-120.3 37.3-184.1 37.3z m0-896c-233.2 0-423 189.7-423 423 0 233.2 189.7 423 423 423s423-189.7 423-423c-0.1-233.2-189.8-423-423-423z"
                fill="#919398"
                p-id="4153"
              />
              <path
                d="M289 756c-5.1 0-10.3-2-14.2-5.9-7.8-7.8-7.8-20.5 0.1-28.3l430.2-428c7.8-7.8 20.5-7.8 28.3 0.1 7.8 7.8 7.8 20.5-0.1 28.3l-430.2 428c-3.9 3.9-9 5.8-14.1 5.8z"
                fill="#919398"
                p-id="4154"
              />
              <path
                d="M729.1 755.1c-5.1 0-10.3-2-14.2-5.9L286.9 319c-7.8-7.8-7.8-20.5 0.1-28.3 7.8-7.8 20.5-7.8 28.3 0.1l428 430.2c7.8 7.8 7.8 20.5-0.1 28.3-3.9 3.9-9 5.8-14.1 5.8z"
                fill="#919398"
                p-id="4155"
              />
            </svg>
          </p>
          <p
            v-show="
              searchValue &&
              (categoryId || brandIds || parameterValue.length > 0)
            "
            class="showValue"
          >
            <span>&nbsp;&nbsp;&gt;&nbsp;&nbsp;</span>
          </p>
          <!-- <div class="showValue"> -->
          <p v-if="categoryId" class="showValueSpan closed">
            <span class="w280">分类：{{ classifyValue }}</span>
            <svg
              @click="resetSearch(0)"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4152"
              width="14"
              height="14"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                d="M514.5 984.6c-63.8 0-125.8-12.5-184.1-37.2C274.1 923.6 223.5 889.5 180 846c-43.4-43.4-77.5-94-101.3-150.3C54 637.4 41.5 575.4 41.5 511.6S54 385.8 78.7 327.5c23.8-56.3 57.9-106.9 101.3-150.3 43.4-43.4 94-77.5 150.3-101.3 58.3-24.7 120.3-37.2 184.1-37.2s125.8 12.5 184.1 37.2c56.3 23.8 106.9 57.9 150.3 101.3 43.4 43.4 77.5 94 101.3 150.3 24.7 58.3 37.2 120.3 37.2 184.1s-12.5 125.8-37.2 184.1C926.4 752 892.3 802.6 848.9 846c-43.4 43.4-94 77.5-150.3 101.3-58.3 24.7-120.3 37.3-184.1 37.3z m0-896c-233.2 0-423 189.7-423 423 0 233.2 189.7 423 423 423s423-189.7 423-423c-0.1-233.2-189.8-423-423-423z"
                fill="#919398"
                p-id="4153"
              />
              <path
                d="M289 756c-5.1 0-10.3-2-14.2-5.9-7.8-7.8-7.8-20.5 0.1-28.3l430.2-428c7.8-7.8 20.5-7.8 28.3 0.1 7.8 7.8 7.8 20.5-0.1 28.3l-430.2 428c-3.9 3.9-9 5.8-14.1 5.8z"
                fill="#919398"
                p-id="4154"
              />
              <path
                d="M729.1 755.1c-5.1 0-10.3-2-14.2-5.9L286.9 319c-7.8-7.8-7.8-20.5 0.1-28.3 7.8-7.8 20.5-7.8 28.3 0.1l428 430.2c7.8 7.8 7.8 20.5-0.1 28.3-3.9 3.9-9 5.8-14.1 5.8z"
                fill="#919398"
                p-id="4155"
              />
            </svg>
          </p>
          <p v-if="brandIds" class="showValueSpan closed">
            <span class="w280">品牌：{{ brandValue }}</span>
            <svg
              @click="resetSearch(2)"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4152"
              width="14"
              height="14"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                d="M514.5 984.6c-63.8 0-125.8-12.5-184.1-37.2C274.1 923.6 223.5 889.5 180 846c-43.4-43.4-77.5-94-101.3-150.3C54 637.4 41.5 575.4 41.5 511.6S54 385.8 78.7 327.5c23.8-56.3 57.9-106.9 101.3-150.3 43.4-43.4 94-77.5 150.3-101.3 58.3-24.7 120.3-37.2 184.1-37.2s125.8 12.5 184.1 37.2c56.3 23.8 106.9 57.9 150.3 101.3 43.4 43.4 77.5 94 101.3 150.3 24.7 58.3 37.2 120.3 37.2 184.1s-12.5 125.8-37.2 184.1C926.4 752 892.3 802.6 848.9 846c-43.4 43.4-94 77.5-150.3 101.3-58.3 24.7-120.3 37.3-184.1 37.3z m0-896c-233.2 0-423 189.7-423 423 0 233.2 189.7 423 423 423s423-189.7 423-423c-0.1-233.2-189.8-423-423-423z"
                fill="#919398"
                p-id="4153"
              />
              <path
                d="M289 756c-5.1 0-10.3-2-14.2-5.9-7.8-7.8-7.8-20.5 0.1-28.3l430.2-428c7.8-7.8 20.5-7.8 28.3 0.1 7.8 7.8 7.8 20.5-0.1 28.3l-430.2 428c-3.9 3.9-9 5.8-14.1 5.8z"
                fill="#919398"
                p-id="4154"
              />
              <path
                d="M729.1 755.1c-5.1 0-10.3-2-14.2-5.9L286.9 319c-7.8-7.8-7.8-20.5 0.1-28.3 7.8-7.8 20.5-7.8 28.3 0.1l428 430.2c7.8 7.8 7.8 20.5-0.1 28.3-3.9 3.9-9 5.8-14.1 5.8z"
                fill="#919398"
                p-id="4155"
              />
            </svg>
          </p>
          <div
            class="closed"
            v-for="(value, index) in parameterValue"
            :key="index"
          >
            <div class="w280">{{ value.name }}：{{ value.childrenVal }}</div>
            <svg
              @click="closeParameter(index)"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4152"
              width="14"
              height="14"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path
                d="M514.5 984.6c-63.8 0-125.8-12.5-184.1-37.2C274.1 923.6 223.5 889.5 180 846c-43.4-43.4-77.5-94-101.3-150.3C54 637.4 41.5 575.4 41.5 511.6S54 385.8 78.7 327.5c23.8-56.3 57.9-106.9 101.3-150.3 43.4-43.4 94-77.5 150.3-101.3 58.3-24.7 120.3-37.2 184.1-37.2s125.8 12.5 184.1 37.2c56.3 23.8 106.9 57.9 150.3 101.3 43.4 43.4 77.5 94 101.3 150.3 24.7 58.3 37.2 120.3 37.2 184.1s-12.5 125.8-37.2 184.1C926.4 752 892.3 802.6 848.9 846c-43.4 43.4-94 77.5-150.3 101.3-58.3 24.7-120.3 37.3-184.1 37.3z m0-896c-233.2 0-423 189.7-423 423 0 233.2 189.7 423 423 423s423-189.7 423-423c-0.1-233.2-189.8-423-423-423z"
                fill="#919398"
                p-id="4153"
              />
              <path
                d="M289 756c-5.1 0-10.3-2-14.2-5.9-7.8-7.8-7.8-20.5 0.1-28.3l430.2-428c7.8-7.8 20.5-7.8 28.3 0.1 7.8 7.8 7.8 20.5-0.1 28.3l-430.2 428c-3.9 3.9-9 5.8-14.1 5.8z"
                fill="#919398"
                p-id="4154"
              />
              <path
                d="M729.1 755.1c-5.1 0-10.3-2-14.2-5.9L286.9 319c-7.8-7.8-7.8-20.5 0.1-28.3 7.8-7.8 20.5-7.8 28.3 0.1l428 430.2c7.8 7.8 7.8 20.5-0.1 28.3-3.9 3.9-9 5.8-14.1 5.8z"
                fill="#919398"
                p-id="4155"
              />
            </svg>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <div class="classify-parameter-recommend-product">
        <div class="classify-recommend">
          <div class="classify-container">
            <p class="all-classify" @click="selectClassify('', '')">全部类型</p>
            <div
              class="classify-item"
              v-for="(classifyFirst, index) in classifyList"
              :key="index"
            >
              <div class="first-classify" @click="openClassify(1, index)">
                <p
                  :class="
                    categoryId === classifyFirst.id
                      ? 'classify-name active-classify-name'
                      : 'classify-name'
                  "
                  @click.stop="
                    selectClassify(classifyFirst.id, classifyFirst.name)
                  "
                >
                  {{ classifyFirst.name }}
                </p>
                <i
                  class="el-icon-arrow-down"
                  v-show="
                    classifyFirst.children.length > 0 && openIndex[0] !== index
                  "
                ></i>
                <i
                  class="el-icon-arrow-up"
                  v-show="
                    classifyFirst.children.length > 0 &&
                    openIndex.length > 0 &&
                    openIndex[0] === index
                  "
                ></i>
              </div>
              <div
                :class="
                  openIndex.length > 0 && openIndex[0] === index
                    ? 'second-classify-container second-classify-open'
                    : 'second-classify-container'
                "
              >
                <div
                  class="second-classify-item"
                  v-for="(classifySecond, i) in classifyFirst.children"
                  :key="i"
                >
                  <div class="second-classify" @click="openClassify(2, i)">
                    <p
                      :class="
                        categoryId === classifySecond.id
                          ? 'classify-name active-classify-name'
                          : 'classify-name'
                      "
                      @click.stop="
                        selectClassify(classifySecond.id, classifySecond.name)
                      "
                    >
                      {{ classifySecond.name }}
                    </p>
                    <i
                      class="el-icon-arrow-down"
                      v-show="
                        classifySecond.children.length > 0 && openIndex[1] !== i
                      "
                    ></i>
                    <i
                      class="el-icon-arrow-up"
                      v-show="
                        classifySecond.children.length > 0 &&
                        openIndex.length === 2 &&
                        openIndex[1] === i
                      "
                    ></i>
                  </div>
                  <ul
                    :class="
                      openIndex.length === 2 && openIndex[1] === i
                        ? 'third-classify-container third-classify-open'
                        : 'third-classify-container'
                    "
                  >
                    <li
                      @click.stop="
                        selectClassify(classifyThird.id, classifyThird.name)
                      "
                      :title="classifyThird.name"
                      class="third-classify"
                      :class="
                        categoryId === classifyThird.id
                          ? 'active-classify-name'
                          : ''
                      "
                      v-for="(classifyThird, ind) in classifySecond.children"
                      :key="ind"
                    >
                      {{ classifyThird.name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="recommend">
            <p class="title">推荐商品</p>
            <ul class="recommend-list">
              <li v-for="(value, index) in recommendData" :key="index">
                <div class="img">
                  <img
                    v-if="value.img"
                    :src="value.img"
                    alt
                    @click="goToProduct(value.id)"
                  />
                  <img
                    v-else
                    src="http://image.8844it.com/ydb2/goodDefault.png"
                    @click="goToProduct(value.id)"
                    alt
                  />
                </div>
                <p class="name" @click="goToProduct(value.id)">
                  {{ value.name }}
                </p>
                <span class="price" v-if="value.price !== ''"
                  >￥{{ value.price }}</span
                >
                <span class="price" v-else>登录享优惠</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="parameter-product">
          <div class="collapse-parameter">
            <div
              :class="
                multi ? 'collapse-container border' : 'collapse-container'
              "
              v-if="!brandIds && brandData.length > 0 && searchLists.length !== 0"
            >
              <div class="collapse">
                <div class="collapse-title">品牌：</div>
                <div class="collapse-content">
                  <ul :class="multi || moreBrand ? 'list h160' : 'list'">
                    <li
                      :title="value.name"
                      v-for="(value, index) in brandData"
                      :key="index"
                      @click="clickOnBrand(value)"
                      :class="checkList.indexOf(value) !== -1 ? 'red' : ''"
                    >
                      {{ value.name }}
                    </li>
                  </ul>
                  <div :class="multi ? 'open' : 'close'">
                    <div :class="checkList.length > 0 ? 'check' : 'check none'">
                      <span class="describe">已选择：</span>
                      <el-checkbox-group v-model="checkList">
                        <el-checkbox
                          v-for="(value, index) in checkList"
                          :label="value"
                          :key="index"
                          >{{ value.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                    <div class="button">
                      <el-button
                        :class="checkList.length > 0 ? 'red' : 'opacity'"
                        :disabled="checkList.length > 0 ? false : true"
                        @click="searchBrandBymulti"
                        >确定</el-button
                      >
                      <el-button @click="closeMulti">取消</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                :class="multi ? 'collapse-more collapse-none' : 'collapse-more'"
              >
                <p @click="more" v-if="brandData.length > 5">
                  <span>更多</span>
                  <svg
                    v-if="moreBrand"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4326"
                    width="10"
                    height="10"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <path
                      d="M191.547 694.475l-58.261-56.285 392.021-393.996 392.021 393.996-58.261 56.285-333.761-331.786z"
                      fill="#919398"
                      p-id="4327"
                    />
                  </svg>
                  <svg
                    v-else
                    viewBox="0 0 1638 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2111"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="10"
                    height="10"
                  >
                    <path
                      d="M89.088 205.4144L205.1072 89.6l729.4976 729.4976-115.8144 115.712z"
                      fill="#919398"
                      p-id="2112"
                    />
                    <path
                      d="M704.2048 818.5856L1433.7024 89.088 1549.6192 204.8 820.1216 934.4z"
                      fill="#919398"
                      p-id="2113"
                    />
                  </svg>
                </p>
                <p @click="multiSelect" v-if="brandData.length > 1">
                  <span>多选</span>
                  <svg
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="3461"
                    width="10"
                    height="10"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <path
                      d="M545.51266541 536.70593574l381.97088847 0.99323251c18.06192817 0.04695652 32.70521739-14.50548204 32.75217391-32.56741021 0.04593573-18.10888469-14.50548204-32.70623819-32.56741021-32.75319471l-382.04030246-1.01568998 0.57776938-380.30801513c0.02245747-17.99353497-14.55243857-32.66030246-32.61436673-32.70725897-18.0394707-0.02245747-32.68378072 14.57489603-32.73073724 32.63784499l-0.5757278 380.21512287-381.7626465-1.01671077c-18.06294896-0.04593573-32.70623819 14.50548204-32.75319469 32.5674102-0.02245747 9.03300567 3.62586011 17.25448014 9.56279772 23.19141777 5.88896031 5.8899811 14.01958412 9.53931947 23.00563327 9.56177694l381.85451796 1.01671078-0.57674858 383.77258979c-0.02347826 9.02994329 3.62688091 17.20650284 9.56279773 23.14241966 5.91345937 5.91345937 14.06654063 9.54034027 23.0525898 9.56381852 18.0394707 0.02245747 32.66030246-14.55243857 32.70623818-32.61436673L545.51266541 536.70593574 545.51266541 536.70593574z"
                      p-id="3462"
                      fill="#919398"
                    />
                  </svg>
                </p>
              </div>
            </div>
            <div class="parameter-container">
              <div
                :class="
                  parameterMultiSelectId === value.id
                    ? 'parameter border'
                    : 'parameter'
                "
                v-for="(value, index) in paramsData"
                :key="index"
              >
                <div class="parameter-title">{{ value.name }}：</div>
                <div class="parameter-content">
                  <div class="parameter-select">
                    <ul
                      :class="
                        parameterMoreId === value.id
                          ? 'parameter-list parameter-list-more'
                          : 'parameter-list'
                      "
                    >
                      <li
                        :class="
                          parameterCheckList.indexOf(v) !== -1
                            ? 'parameter-li red'
                            : 'parameter-li'
                        "
                        v-for="(v, i) in value.children"
                        :key="i"
                        @click="clickOnParameter(value.id, value.name, v)"
                      >
                        {{ v.value }}
                      </li>
                    </ul>
                    <div
                      :class="
                        parameterMultiSelectId === value.id ? 'select' : 'close'
                      "
                    >
                      <div
                        :class="
                          parameterCheckList.length > 0 ? 'check' : 'check none'
                        "
                      >
                        <span class="describe">已选择：</span>
                        <el-checkbox-group v-model="parameterCheckList">
                          <el-checkbox
                            v-for="(value, index) in parameterCheckList"
                            :label="value"
                            :key="index"
                            >{{ value.value }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                      <div class="button">
                        <el-button
                          :class="
                            parameterCheckList.length > 0 ? 'red' : 'opacity'
                          "
                          :disabled="
                            parameterCheckList.length > 0 ? false : true
                          "
                          @click="searchParameterBymulti"
                          >确定</el-button
                        >
                        <el-button @click="closeParameterMulti">取消</el-button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="parameter-operation"
                    v-if="parameterMultiSelectId !== value.id"
                  >
                    <p
                      @click="parameterMore(value.id)"
                      v-if="value.children.length > 5"
                    >
                      <span>更多</span>
                      <svg
                        v-if="parameterMoreId === value.id"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="4326"
                        width="10"
                        height="10"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M191.547 694.475l-58.261-56.285 392.021-393.996 392.021 393.996-58.261 56.285-333.761-331.786z"
                          fill="#919398"
                          p-id="4327"
                        />
                      </svg>
                      <svg
                        v-else
                        viewBox="0 0 1638 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2111"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="10"
                        height="10"
                      >
                        <path
                          d="M89.088 205.4144L205.1072 89.6l729.4976 729.4976-115.8144 115.712z"
                          fill="#919398"
                          p-id="2112"
                        />
                        <path
                          d="M704.2048 818.5856L1433.7024 89.088 1549.6192 204.8 820.1216 934.4z"
                          fill="#919398"
                          p-id="2113"
                        />
                      </svg>
                    </p>
                    <p
                      @click="parameterMultiSelect(value.id, value.name)"
                      v-if="value.children.length > 1"
                    >
                      <span>多选</span>
                      <svg
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="3461"
                        width="10"
                        height="10"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M545.51266541 536.70593574l381.97088847 0.99323251c18.06192817 0.04695652 32.70521739-14.50548204 32.75217391-32.56741021 0.04593573-18.10888469-14.50548204-32.70623819-32.56741021-32.75319471l-382.04030246-1.01568998 0.57776938-380.30801513c0.02245747-17.99353497-14.55243857-32.66030246-32.61436673-32.70725897-18.0394707-0.02245747-32.68378072 14.57489603-32.73073724 32.63784499l-0.5757278 380.21512287-381.7626465-1.01671077c-18.06294896-0.04593573-32.70623819 14.50548204-32.75319469 32.5674102-0.02245747 9.03300567 3.62586011 17.25448014 9.56279772 23.19141777 5.88896031 5.8899811 14.01958412 9.53931947 23.00563327 9.56177694l381.85451796 1.01671078-0.57674858 383.77258979c-0.02347826 9.02994329 3.62688091 17.20650284 9.56279773 23.14241966 5.91345937 5.91345937 14.06654063 9.54034027 23.0525898 9.56381852 18.0394707 0.02245747 32.66030246-14.55243857 32.70623818-32.61436673L545.51266541 536.70593574 545.51266541 536.70593574z"
                          p-id="3462"
                          fill="#919398"
                        />
                      </svg>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="isOpen" v-if="paramsDataAll.length > 4">
              <p v-show="!isOpen" @click="isOpen = true">展开</p>
              <p v-show="isOpen" @click="isOpen = false">收起</p>
            </div>
          </div>
          <div class="recommend-product-list">
            <div class="product-list">
              <div class="title">
                <div class="title-left">
                  <ul class="title-left-list">
                    <li
                      class="title-left-list-li"
                      :class="defaultValue == value.label ? 'borderBottom' : ''"
                      @click="reorder(value.label)"
                      v-for="(value, index) in sort"
                      :key="index"
                    >
                      <span>{{ value.name }}</span>
                      <div v-if="value.label === 'salesVolume'" class="svg">
                        <svg
                          :class="
                            defaultValue === 'salesVolume' &&
                            salesVolumeStatus === 1
                              ? 'top'
                              : ''
                          "
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2216"
                          width="12"
                          height="12"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <path
                            d="M512.064 288.72l278.4 279.68-45.376 45.12-232.704-233.791-231.616 236.032-45.632-44.8z"
                            p-id="2217"
                          />
                        </svg>
                        <svg
                          :class="
                            defaultValue === 'salesVolume' &&
                            salesVolumeStatus === 0
                              ? 'bottom'
                              : ''
                          "
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2041"
                          width="12"
                          height="12"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <path
                            d="M511.936 621.504l-278.4-279.68 45.376-45.12 232.704 233.792 231.616-236.032 45.632 44.8z"
                            p-id="2042"
                          />
                        </svg>
                      </div>
                      <div v-if="value.label === 'price'" class="svg">
                        <svg
                          :class="
                            defaultValue === 'price' && priceStatus === 1
                              ? 'top'
                              : ''
                          "
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2216"
                          width="12"
                          height="12"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <path
                            d="M512.064 288.72l278.4 279.68-45.376 45.12-232.704-233.791-231.616 236.032-45.632-44.8z"
                            p-id="2217"
                          />
                        </svg>
                        <svg
                          :class="
                            defaultValue === 'price' && priceStatus === 0
                              ? 'bottom'
                              : ''
                          "
                          viewBox="0 0 1024 1024"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          p-id="2041"
                          width="12"
                          height="12"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <path
                            d="M511.936 621.504l-278.4-279.68 45.376-45.12 232.704 233.792 231.616-236.032 45.632 44.8z"
                            p-id="2042"
                          />
                        </svg>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="title-right">
                  <span class="deliver" v-if="isModuleStorage">
                    <span v-if="!address[address.length - 1]">收货地</span>
                    <span v-else class="deliver-tit">{{
                      address[address.length - 1].name
                    }}</span>
                    <img
                      class="deliverImg"
                      src="../../../assets/search/arrow-down.png"
                    />
                    <div class="deliver-address">
                      <div class="deliver-title" v-if="address.length === 0">
                        <div class="deliver-title-address">省市区：</div>
                        <div class="deliver-title-content">
                          <span>
                            <img
                              src="../../../assets/inventory/replenishment.png"
                              alt
                            />
                          </span>
                          <span>请选择收货区域，将为您展示本地仓商品</span>
                        </div>
                      </div>
                      <div class="deliver-title" v-else>
                        <el-button class="btn" @click="cancleAddress"
                          >取消选择</el-button
                        >
                        <div class="detailedAddress">
                          省市区：
                          <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item
                              :class="{ activeTitle: flag === item.name }"
                              v-for="(item, index) in address"
                              :key="index"
                              >{{ item.name }}</el-breadcrumb-item
                            >
                          </el-breadcrumb>
                        </div>
                      </div>
                      <div class="deliver-address-content">
                        <div>
                          <span
                            :class="{ active: flag === item.name }"
                            v-for="(item, index) in addressList"
                            :key="index"
                            @click="clickAddress(item)"
                            >{{ item.name }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </span>
                  <svg class="icon manner" v-if="manner === 0">
                    <use xlink:href="#icon-方块列表-选" />
                  </svg>
                  <svg class="icon manner" v-else @click="changeRange(0)">
                    <use xlink:href="#icon-方块列表-未选" />
                  </svg>
                  <svg class="icon manner" v-if="manner === 1">
                    <use xlink:href="#icon-列列表-选" />
                  </svg>
                  <svg class="icon manner" v-else @click="changeRange(1)">
                    <use xlink:href="#icon-列列表-未选" />
                  </svg>
                  <svg class="icon manner" v-if="manner === 2">
                    <use xlink:href="#icon-横列表-选" />
                  </svg>
                  <svg class="icon manner" v-else @click="changeRange(2)">
                    <use xlink:href="#icon-横列表-未选" />
                  </svg>
                </div>
              </div>
              <div class="content-container" v-if="(searchLists.length > 0)&&(!nothing)">
                <div v-if="manner == 0" class="lump">
                  <ul class="list">
                    <li v-for="(value, index) in searchLists" :key="index">
                      <div class="img" @click="goToProduct(value.id)">
                        <el-image
                          style="width: 140px; height: 140px"
                          :fit="'contain'"
                          v-if="value.img"
                          :src="value.img"
                          lazy
                        ></el-image>
                        <el-image
                          style="width: 140px; height: 140px"
                          :fit="'contain'"
                          v-else
                          src="http://image.8844it.com/ydb2/goodDefault.png"
                          lazy
                        ></el-image>
                      </div>
                      <div class="price">
                        <div class="price-container" v-if="value.price !==''">
                          <span class="new-price" v-if="value.promotionStatus === 0">￥{{ value.price.toFixed(2) }}</span>
                          <span class="new-price" v-else>￥{{ (value.price-value.promotionReduce).toFixed(2) }}</span>
                          <span class="old-price" v-if="value.promotionReduce>0&&value.promotionStatus === 1">￥{{ value.price }}</span>
                        </div>
                        <span v-else class="no-price">登录享优惠</span>
                        <span v-if="isModuleSelection" class="commission-rate"
                          >抽佣:{{ value.commissionRate }}%</span
                        >
                      </div>
                      <p
                        class="tit"
                        @click="goToProduct(value.id)"
                        :title="value.name"
                      >
                        {{ value.name }}
                      </p>
                      <div class="labels">
                        <span
                          class="promotionLabel"
                          v-if="value.promotionStatus === 1"
                          >促销</span
                        >
                        <span
                          class="collectionLabel"
                          v-if="value.setMealStatus === 1"
                          >套餐</span
                        >
                        <span class="label" v-if="value.label.length > 0" :title="value.labelNameTitle">
                          <span :class="index === 2?'backWhite':'labelName'" v-for="(item, index) in value.label" :key="index">
                            <span v-show="index !== 2">{{ item }}</span>
                            <span v-show="index === 2">...</span>
                          </span>
                        </span>
                      </div>
                      <div
                        :class="
                          isModuleSelection
                            ? 'button isSelect addCart' + index
                            : 'button addCart' + index
                        "
                      >
                        <el-button
                          class="addCart"
                          v-if="value.totalSaleSum > 0"
                          @click="inCart(value, index)"
                          >加入购物车</el-button
                        >
                        <el-button v-else disabled class="gray"
                          >商品已售罄</el-button
                        >
                        <el-button
                          v-if="isModuleSelection"
                          class="addCollection"
                          @click="inSelectionCart(value.id)"
                        >
                          <svg
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="11805"
                            width="13"
                            height="13"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <path
                              d="M921.6 20.48H102.4C57.344 20.48 20.48 57.344 20.48 102.4v819.2c0 45.056 36.864 81.92 81.92 81.92h409.6v-61.44H122.88c-22.528 0-40.96-18.432-40.96-40.96V122.88c0-22.528 18.432-40.96 40.96-40.96h778.24c22.528 0 40.96 18.432 40.96 40.96v512h61.44V102.4c0-45.056-36.864-81.92-81.92-81.92z"
                              p-id="11806"
                              fill="#999999"
                            />
                            <path
                              d="M266.24 245.76v188.416C266.24 567.296 376.832 675.84 512 675.84s245.76-108.544 245.76-241.664V245.76h-61.44v188.416c0 88.064-94.208 180.224-184.32 180.224s-184.32-92.16-184.32-180.224V245.76h-61.44zM950.272 722.944L741.376 933.888l-79.872-79.872c-12.288-12.288-30.72-12.288-43.008 0s-12.288 30.72 0 43.008l94.208 94.208c16.384 16.384 40.96 16.384 57.344 0l225.28-225.28c12.288-12.288 12.288-30.72 0-43.008s-32.768-12.288-45.056 0z"
                              p-id="11807"
                              fill="#999999"
                            />
                          </svg>
                          <span>选品</span>
                        </el-button>
                        <el-button
                          class="addCollection"
                          @click="
                            inCollection(
                              value.id,
                              value.collectionStatus,
                              index
                            )
                          "
                        >
                          <svg
                            v-if="value.collectionStatus === 1"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="7896"
                            width="13"
                            height="13"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <path
                              d="M786.309939 1003.349333c-11.093333 0-23.893333-3.754667-34.986666-9.216l-239.616-119.808L270.043273 994.133333c-23.893333 12.970667-55.296 11.093333-77.482667-5.461333s-34.986667-46.08-29.525333-73.728l49.834666-258.048L23.088606 479.914667C2.779273 459.605333-4.559394 428.202667 2.779273 402.432c9.216-27.648 31.402667-47.957333 60.757333-51.541333l263.68-47.957334L445.317939 63.146667c12.970667-25.770667 38.741333-42.325333 66.389334-42.325334S567.003273 37.376 578.096606 63.146667l117.930667 239.616 263.68 46.08c27.648 3.754667 51.541333 23.893333 59.050666 51.541333 9.216 27.648 1.877333 57.173333-18.432 77.482667L810.203273 656.896l47.957333 258.048c5.461333 29.525333-7.338667 57.173333-29.525333 73.728-10.922667 9.216-25.770667 14.677333-42.325334 14.677333z"
                              fill="#DF3445"
                              p-id="7897"
                            />
                          </svg>
                          <svg
                            v-else
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            p-id="7577"
                            width="13"
                            height="13"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <path
                              d="M773.461 1005.431c-14.404 0-30.583-4.13-45.602-11.639L513.57 886.613 297.95 993.621c-13.653 7.27-29.287 11.094-45.227 11.094a96.256 96.256 0 0 1-57.549-18.842c-30.173-22.63-45.636-61.85-38.502-97.553l44.1-228.762-169.028-157.56A104.073 104.073 0 0 1 5.461 401.34l0.342-1.16c12.288-36.83 42.769-62.635 79.735-67.585l234.837-42.7L425.78 75.81c16.93-33.894 51.37-55.671 87.791-55.671 37.99 0 73.319 22.596 88.132 56.286l105.063 213.401 234.871 41.063a95.676 95.676 0 0 1 78.268 68.369 98.987 98.987 0 0 1-24.474 101l-0.58 0.58-168.55 158.72 42.598 229.172c6.86 36.659-7.714 73.66-38.059 96.733a90.283 90.283 0 0 1-57.378 19.968zM513.673 824.286l239.104 119.569c7.031 3.55 15.12 5.768 20.65 5.768 8.534 0 16.452-2.628 22.255-7.475l1.092-0.887c13.585-10.206 20.207-26.385 17.238-42.257l-48.128-259.209L956.21 460.561c11.674-11.844 15.667-28.808 10.48-44.407l-0.513-1.639a39.185 39.185 0 0 0-32.529-28.365l-1.092-0.17-263.339-46.046L550.708 99.19c-5.77-13.448-21.368-23.21-37.138-23.21-15.496 0-30.31 9.694-37.82 24.678L357.99 339.831 93.252 387.925c-16.077 2.014-28.57 12.698-34.338 29.355-4.096 15.223 0.751 33.553 11.947 44.988l190.532 177.561-50.005 259.345c-3.004 14.985 4.096 32.256 17.237 42.12 6.588 4.95 15.121 7.68 24.064 7.68 6.895 0 13.517-1.603 19.217-4.675l0.82-0.478 240.947-119.535z"
                              p-id="7578"
                              fill="#999999"
                            />
                          </svg>
                          <span>收藏</span>
                        </el-button>
                        <transition
                          v-on:before-enter="beforeEnter"
                          v-on:enter="enter"
                          v-on:after-enter="afterEnter"
                          v-on:enter-cancelled="enterCancelled"
                        >
                          <div
                            v-show="value.addCartShow"
                            :class="
                              'img-fade-container img-fade-container' + index
                            "
                          >
                            <el-image
                              style="width: 25px; height: 25px"
                              :fit="'contain'"
                              v-if="value.img"
                              :src="value.img"
                            ></el-image>
                            <el-image
                              style="width: 25px; height: 25px"
                              :fit="'contain'"
                              v-else
                              src="http://image.8844it.com/ydb2/goodDefault.png"
                              lazy
                            ></el-image>
                          </div>
                        </transition>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-if="manner == 1" class="two-block">
                  <ul class="list">
                    <li v-for="(value, index) in searchLists" :key="index">
                      <div class="img" @click="goToProduct(value.id)">
                        <el-image
                          style="width: 68px; height: 68px"
                          :fit="'contain'"
                          v-if="value.img"
                          :src="value.img"
                          lazy
                        ></el-image>
                        <el-image
                          style="width: 68px; height: 68px"
                          :fit="'contain'"
                          v-else
                          src="http://image.8844it.com/ydb2/goodDefault.png"
                          lazy
                        ></el-image>
                      </div>
                      <div class="content-right">
                        <div class="tit-specifications">
                          <p class="tit">
                            <span
                              class="tit-link"
                              @click="goToProduct(value.id)"
                              :title="value.name"
                              >{{ value.name }}</span
                            >
                          </p>
                          <div class="labels">
                            <span
                              class="promotionLabel"
                              v-if="value.promotionStatus === 1"
                              >促销</span
                            >
                            <span
                              class="collectionLabel"
                              v-if="value.setMealStatus === 1"
                              >套餐</span
                            >
                            <span class="label" v-if="value.label.length > 0">
                              <span>{{ value.labelNameTitle }}</span>
                            </span>
                          </div>
                          <div class="specifications">
                            <p
                              class="specifications-child"
                              v-for="(v, i) in value.specifications"
                              :key="i"
                            >
                              <span class="specifications-child-title"
                                >{{ v.title }}：</span
                              >
                              <el-select
                                :title="v.value"
                                v-model="v.value"
                                class="gray"
                                @change="changeSku(index)"
                              >
                                <el-option
                                  v-for="item in v.options"
                                  :key="item.name"
                                  :value="item.name"
                                ></el-option>
                              </el-select>
                            </p>
                          </div>
                        </div>
                        <div class="content-number-store-price-cart">
                          <div class="number-store">
                            <el-input-number
                              v-model="value.num"
                              :min="1"
                              :max="value.maxNum"
                              label="描述文字"
                            ></el-input-number>
                            <p class="store">
                              <span>库存：</span>
                              <span>{{ value.maxNum?value.maxNum:0 }}</span>
                            </p>
                          </div>
                          <div class="price-cart">
                            <span v-if="value.price !== ''" class="price"
                              >￥{{ value.price }}</span
                            >
                            <span v-else class="no-price">登录享优惠</span>
                            <el-button
                              v-if="value.maxNum > 0"
                              @click="inCartNumber(index)"
                              :class="'button addCart' + index"
                              >加入购物车</el-button
                            >
                            <el-button v-else class="nothing" disabled
                              >商品已售罄</el-button
                            >
                            <transition
                              v-on:before-enter="beforeEnter"
                              v-on:enter="enter"
                              v-on:after-enter="afterEnter"
                              v-on:enter-cancelled="enterCancelled"
                            >
                              <div
                                v-show="value.addCartShow"
                                :class="
                                  'img-fade-container img-fade-container' +
                                  index
                                "
                              >
                                <el-image
                                  style="width: 25px; height: 25px"
                                  :fit="'contain'"
                                  v-if="value.img"
                                  :src="value.img"
                                ></el-image>
                                <el-image
                                  style="width: 25px; height: 25px"
                                  :fit="'contain'"
                                  v-else
                                  src="http://image.8844it.com/ydb2/goodDefault.png"
                                  lazy
                                ></el-image>
                              </div>
                            </transition>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div v-if="manner == 2" class="tabulation">
                  <ul class="list">
                    <li v-for="(value, index) in searchLists" :key="index">
                      <p class="tit">
                        <span
                          :title="value.name"
                          class="tit-link"
                          @click="goToProduct(value.id)"
                          >{{ value.name }}</span
                        >
                      </p>
                      <div class="labels">
                        <span
                          class="promotionLabel"
                          v-if="value.promotionStatus === 1"
                          >促销</span
                        >
                        <span
                          class="collectionLabel"
                          v-if="value.setMealStatus === 1"
                          >套餐</span
                        >
                        <span class="label" v-if="value.label.length > 0">
                          <span>{{ value.labelNameTitle }}</span>
                        </span>
                      </div>
                      <div class="price-car">
                        <span v-if="value.price !== ''" class="price"
                          >￥{{ value.price }}</span
                        >
                        <span v-else class="no-price">登录享优惠</span>
                        <el-button
                          v-if="value.totalSaleSum > 0"
                          @click="inCart(value)"
                          >加入购物车</el-button
                        >
                        <el-button v-else class="nothing" disabled
                          >商品已售罄</el-button
                        >
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="pagination">
                  <PaginationModul
                    @queryChange="updatePage"
                    :total="total"
                    :currentPage="page"
                    :pageSize="pageSize"
                  ></PaginationModul>
                </div>
              </div>
              <div v-show="(searchLists.length <= 0)&&(!nothing)" class="nothingNum">
                <!-- <span>暂无数据</span> -->
                <img src="../../../assets/search/searchNothing.png">
              </div>
              <div v-show="nothing" class="nothing">
                <img src="../../../assets/search/nothing.png">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <right-sidebar
      :carDate="carDate"
      :commodityDate="commodityDate"
      :selectionDate="selectionDate"
      @slideStatus="slideStatus"
    ></right-sidebar>
  </div>
</template>

<script>
import Velocity from "velocity-animate";
import { handleGetRequestParams } from "common/js/util.js";
import {
  getToken,
  getXBGuestSetting,
  getXBBasicInformation,
  saveXbTouristCartGoods,
  getXbTouristCartGoods,
  saveXBReceivingGoodsAddressInfo,
  getXBReceivingGoodsAddressInfo,
  deleteXBReceivingGoodsAddressInfo
} from "common/js/storage";
import eventVue from "common/js/eventBus";
import Header from "base/xb-base/Header";
import Search from "base/xb-base/Search";
import NavMenu from "base/xb-base/NavMenu";
import Footer from "base/xb-base/Footer";
import PaginationModul from "base/PaginationTpl";
import RightSidebar from "base/xb-base/RightSidebar";
import XBSearch from "models/xb/search.js";
import XBShoppingCart from "models/xb/shopping-cart.js";
import XBHome from "models/xb/home.js";
import XBRecommend from "models/xb/recommend.js";
import XBProduct from "models/xb/product.js";
import XBSelectionCart from "models/xb/selection-cart.js";
import DBAddress from "models/db/address.js";
const dbAddress = new DBAddress();
const xbHome = new XBHome();
const xbSearch = new XBSearch();
const xbShoppingCart = new XBShoppingCart();
const xbRecommend = new XBRecommend();
const xbProduct = new XBProduct();
const xbSelectionCart = new XBSelectionCart();
export default {
  components: {
    Header,
    Search,
    NavMenu,
    Footer,
    PaginationModul,
    RightSidebar,
  },
  data() {
    return {
      column: [], // 栏目数据
      lists: [], // 分类数据
      carDate: 0, // 触发加入购物车
      commodityDate: 0, // 触发加入收藏夹
      selectionDate: 0, //触发加入选品池
      showValue: "", // 展示的值
      brandValue: "", //品牌展示值
      classifyValue: "", //分类展示值
      moreBrand: false, // 展示品牌更多
      multi: false, // 展示品牌多选
      brandData: [], // 品牌数据
      checkList: [], // 多选品牌
      brandIds: "", // 品牌ids
      paramsData: [], //显示的参数数据
      paramsDataAll: [], //所有的参数数据
      parameterMoreId: "", //选择参数更多数据的id
      parameterMultiSelectId: "", //选择参数多选数据的id
      parameterMultiSelectName: "", //选择参数多选数据的name
      parameterCheckList: [], //多选的参数
      parameterIds: "", //进行搜索的参数
      parameterValue: [], //显示的参数
      isOpen: false,
      recommendData: [], // 商品推荐数据
      searchValue: "", // 展示并搜索的值
      categoryId: null,
      active: null,
      sort: [
        {
          name: "综合",
          label: "synthesize", // 综合
        },
        {
          name: "销量",
          label: "salesVolume", // 销量
        },
        {
          name: "价格",
          label: "price", // 价格
        },
      ],
      defaultValue: "synthesize", // 默认排序方式
      salesVolumeStatus: 1, // 销量升序
      priceStatus: 1, // 价格升序
      manner: 0, // 切换板块
      searchLists: [], // 搜索结果
      page: 1, // 当前页
      pageSize: 20, // 每页多少条数据
      total: 0, // 总数量
      touristRights: {},
      token: "",
      showPrice: false,
      //加入购物车动画开关
      addCartShow: false,
      slide: false,
      //所有分类数据
      classifyList: [],
      openIndex: [],
      //选品池
      isModuleSelection: false,
      isModuleStorage: false,
      address: [
        // '浙江省','杭州市','西湖区'
      ],
      addressList: [],
      flag: "",
      city: "", //市
      region: "", //区域
      nothing: false,
      addressCopy: [],
      selectCartGoods: [] //  游客时加入购物车时的商品数据
    };
  },
  watch: {
    isOpen: {
      handler(value) {
        if (value) {
          this.paramsData = this.paramsDataAll;
        } else {
          this.paramsData = this.paramsDataAll.slice(0, 4);
        }
      },
    },
    $route: {
      handler(newVal, oldVal) {
        this.searchValue = this.$route.query.value
          ? this.$route.query.value
          : "";
        this.categoryId = this.$route.query.categoryId
          ? this.$route.query.categoryId
          : "";
        this.classifyValue = this.$route.query.classifyValue
          ? this.$route.query.classifyValue
          : "";
        this.brandIds = this.$route.query.brandIds
          ? this.$route.query.brandIds
          : "";
        this.brandValue = this.$route.query.brandValue
          ? this.$route.query.brandValue
          : "";
        this.parameterValue = this.$route.query.parameterValue
          ? JSON.parse(this.$route.query.parameterValue)
          : [];
        this.getSearchValue();
      },
    },
  },
  created() {
    this.touristRights = getXBGuestSetting();
    this.token = getToken() ? getToken() : "";
    if (!this.token) {
      this.selectCartGoods = getXbTouristCartGoods()
    }
    if (getXBBasicInformation().moduleStorage) {
      this.isModuleStorage =
        getXBBasicInformation().moduleStorage === 1 ? true : false;
      if(!this.isModuleStorage) {
        deleteXBReceivingGoodsAddressInfo()
      }
    }
    this.getMenu();
    this.getColumnData();
    this.getRecommend();
    this.getClassifyList();
    this._getDBAddressMock();
    this.initAddressSearch()
  },
  beforeMount() {
    this.searchValue = this.$route.query.value ? this.$route.query.value : "";
    this.categoryId = this.$route.query.categoryId
      ? this.$route.query.categoryId
      : "";
    this.classifyValue = this.$route.query.classifyValue
      ? this.$route.query.classifyValue
      : "";
    this.brandIds = this.$route.query.brandIds
      ? this.$route.query.brandIds
      : "";
    this.brandValue = this.$route.query.brandValue
      ? this.$route.query.brandValue
      : "";
    this.parameterValue = this.$route.query.parameterValue
      ? JSON.parse(this.$route.query.parameterValue)
      : [];
    this.getSearchValue();
  },
  mounted() {
    this.getModuleSelection();
  },
  methods: {
    _getDBAddressMock() {
      dbAddress.getDBAddressMock().then((res) => {
        // console.log('城市数据--', res);
        let arr = res;
        arr.map((item) => {
          if (item.name.substr(item.name.length - 1, 1) === "省") {
            item.name = item.name.split("省")[0];
          }
          if (item.name.substr(item.name.length - 1, 1) === "区") {
            item.name = item.name.substr(0, 2);
          }
          if (item.name === "内蒙") {
            item.name = "内蒙古";
          }
        });
        this.addressList = arr;
      });
    },
    initAddressSearch() {
      let addressList = getXBReceivingGoodsAddressInfo();
      if (addressList.length != 0) {
        this.address = addressList
        this.city = this.address[1].id;
        this.region = this.address[2].id;
        this.getSearchValue();
      }
    },
    clickAddress(v) {
      this.flag = v.name;
      this.addressCopy.push(v);
      if (this.addressCopy.length > 3) {
        this.addressCopy = [
          this.addressCopy[0],
          this.addressCopy[1],
          this.addressCopy[this.addressCopy.length - 1],
        ];
      }
      this.address = this.addressCopy
      let arr = []
      this.address.map(item => {
        let obj = {}
        obj.id = item.id
        obj.name = item.name
        arr.push(obj)
      })
      saveXBReceivingGoodsAddressInfo(arr)
      if (this.address.length == 2) {
        this.city = this.address[1].id;
      }
      if (this.address.length == 3) {
        this.region = this.address[2].id;
      }
      this.addressList.map((item) => {
        if (v.id === item.id) {
          if (item.children) {
            this.sortList(item.children)
            this.addressList = item.children;
          } else {
            this.getSearchValue();
            return;
          }
        }
      });
    },
    //排序
    sortList(list) {
      return list.sort((a,b) => {
        return a['name'].length - b['name'].length
      })
    },
    cancleAddress() {
      this.city = ''
      this.region = ''
      this.address = [];
      this.addressCopy = [];
      this.addressList = [];
      this.getSearchValue();
      this._getDBAddressMock();
      deleteXBReceivingGoodsAddressInfo()
    },
    // 获取侧边栏数据
    getMenu() {
      xbHome.getXBMenu().then((res) => {
        let arr = [];
        res.result.map((value) => {
          let object = {};
          object.name = value.name;
          object.id = value.categoryId;
          object.children = [];
          value.children.map((val) => {
            let obj = {};
            obj.name = val.name;
            obj.id = val.categoryId;
            obj.children = [];
            val.children.map((v) => {
              let o = {};
              o.name = v.name;
              o.id = v.categoryId;
              obj.children.push(o);
            });
            object.children.push(obj);
          });
          arr.push(object);
        });
        this.lists = arr;
      });
    },
    // 获取栏目信息
    getColumnData() {
      xbHome.getXBColumn().then((res) => {
        this.column = res.result;
      });
    },
    //获取参数和品牌数据
    getParamsData(ids) {
      let goodsName = this.searchValue;
      let category1Id = this.categoryId;
      let brandIds = this.brandIds;
      let valueIds = ids;
      let obj = {
        goodsName,
        category1Id,
        brandIds,
        valueIds,
      };
      let data = handleGetRequestParams(obj);
      xbSearch.getParamsList(data).then((res) => {
        if (res.success) {
          let arrParams = [];
          let arrBrand = [];
          let selectParamsIds = [];
          this.parameterValue.map((value) => {
            selectParamsIds.push(value.id);
          });
          res.result.goodsParams.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.children = value.goodsParamsValuesList;
            if (selectParamsIds.indexOf(value.id) === -1) {
              arrParams.push(obj);
            }
          });
          this.paramsDataAll = arrParams;
          res.result.brandList.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arrBrand.push(obj);
          });
          this.brandData = arrBrand;

          if (this.paramsDataAll.length > 4) {
            this.isOpen = false;
            this.paramsData = this.paramsDataAll.slice(0, 4);
          } else {
            this.isOpen = true;
            this.paramsData = this.paramsDataAll;
          }
        } else {
          this.message.$error(res.message);
        }
      });
    },
    // 获取推荐数据
    getRecommend() {
      xbRecommend.getXBRecommend().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.name = value.goodsName;
            if (value.itemImages) {
              obj.img = value.itemImages[0];
            }
            // obj.price = value.defaultPrice;
            if (this.token) {
              obj.price = value.defaultPrice;
            } else {
              if (this.touristRights.guestShowPrice === 1) {
                obj.price = value.defaultPrice;
              } else {
                obj.price = "";
              }
            }
            obj.id = value.goodsId;
            arr.push(obj);
          });
          this.recommendData = arr;
        }
      });
    },
    //获取商品分类
    getClassifyList() {
      xbSearch.getXBGoodscate().then((res) => {
        if (res.success) {
          let classifyList = [];
          res.result.map((value, index) => {
            if (value.cateLevel !== 0) {
              let object = {};
              object.id = value.id;
              object.name = value.cateName;
              object.children = [];
              if (value.children.length > 0) {
                value.children.map((val) => {
                  let obj = {};
                  obj.id = val.id;
                  obj.name = val.cateName;
                  obj.children = [];
                  if (val.children.length > 0) {
                    val.children.map((v) => {
                      let o = {};
                      o.id = v.id;
                      o.name = v.cateName;
                      obj.children.push(o);
                    });
                  }
                  object.children.push(obj);
                });
              }
              classifyList.push(object);
            }
          });
          this.classifyList = classifyList;
        }
      });
    },
    // 获取当前搜索数据
    getSearchValue() {
      let currentPage = this.page;
      let goodsName = this.searchValue;
      let orderField = null;
      let order = null;
      let category1Id = this.categoryId;
      let brandIds = this.brandIds;
      let valueIds = "";
      let region = this.region;
      let city = this.city;
      this.parameterValue.map((value) => {
        if (value.more) {
          value.children.map((v, i) => {
            if (i < value.children.length - 1) {
              valueIds += v.id + "_";
            } else {
              valueIds += v.id + "-";
            }
          });
        } else {
          value.children.map((v) => {
            valueIds += v.id + "-";
          });
        }
      });
      valueIds = valueIds.slice(0, valueIds.length - 1);
      if (this.defaultValue === "synthesize") {
        orderField = null;
      } else if (this.defaultValue === "salesVolume") {
        orderField = "saleTotal";
        order = this.salesVolumeStatus > 0 ? "up" : "down";
      } else if (this.defaultValue === "price") {
        orderField = "defaultPrice";
        order = this.priceStatus > 0 ? "up" : "down";
      }
      let obj = {
        currentPage,
        goodsName,
        orderField,
        order,
        category1Id,
        brandIds,
        valueIds,
        region,
        city,
      };
      let data = handleGetRequestParams(obj);
      this.getParamsData(valueIds);
      xbSearch.getXBSearchList(data).then((res) => {
        if (res.success) {
          this.total = res.result.totalNum;
          this.pageSize = res.result.pageSize;
          let arr = [];
          if(res.result.items) {
            res.result.items.map((value, index) => {
              let obj = {};
              obj.id = value.id;
              obj.name = value.goodsName;
              obj.addCartShow = false;
              obj.totalSaleSum = value.totalSaleSum;
              obj.items = value.items;
              obj.collectionStatus = value.collectionStatus;
              obj.promotionStatus = value.promotionStatus;
              obj.setMealStatus = value.setMealStatus;
              obj.skuId = null;
              obj.num = 1;
              obj.img = value.itemImages.length > 0 ? value.itemImages[0] : "";
              obj.label = value.labelNameList;
              let title = ''
              obj.label.map(i => {
                title += `，${i}`
              })
              obj.labelNameTitle = title.substring(1)
              obj.commissionRate = (value.commissionRate * 100).toFixed(2);
              obj.promotionReduce = value.promotionReduce;
              if (this.token) {
                obj.price = value.defaultPrice;
                this.showPrice = true;
              } else {
                if (this.touristRights.guestShowPrice === 1) {
                  obj.price = value.defaultPrice;
                  this.showPrice = true;
                } else {
                  obj.price = "";
                }
              }
              value.items.map((v) => {
                if (v.isDefault) {
                  obj.maxNum = v.saleNum;
                }
              });
              let specificationItems = value.specificationItems;
              let Arr = [];
              specificationItems.map((v) => {
                let object = {};
                object.title = v.name;
                object.value = v.value[0];
                object.options = [];
                v.value.map((val) => {
                  let objOptions = {};
                  objOptions.name = val;
                  object.options.push(objOptions);
                });
                Arr.push(object);
              });
              obj.specifications = Arr;
              arr.push(obj);
            });
          }
          this.searchLists = arr;
          this.nothing = false
        } else {
          if (res.code == 500) {
            this.nothing = true
          }
        }
      });
    },
    // 从新排序
    reorder(value) {
      if (value === "synthesize") {
        if (this.defaultValue !== value) {
          this.defaultValue = value;
          this.getSearchValue();
        }
      } else if (value === "salesVolume") {
        if (this.defaultValue === value) {
          this.salesVolumeStatus = this.salesVolumeStatus === 0 ? 1 : 0;
          this.getSearchValue();
        } else {
          this.defaultValue = value;
          this.getSearchValue();
        }
      } else if (value === "price") {
        if (this.defaultValue === value) {
          this.priceStatus = this.priceStatus === 0 ? 1 : 0;
          this.getSearchValue();
        } else {
          this.defaultValue = value;
          this.getSearchValue();
        }
      }
    },
    // 下拉框发生改变
    changeSku(index) {
      let obj = {};
      this.searchLists[index].specifications.map((value) => {
        obj[value.title] = value.value;
      });
      // console.log(obj);
      console.log(this.searchLists[index]);
      let strObj = JSON.stringify(obj);
      this.searchLists[index].items.map((value) => {
        let specInfo = {};
        this.searchLists[index].specifications.map((val) => {
          specInfo[val.title] = value.specInfo[val.title];
        });
        console.log(JSON.stringify(specInfo), strObj);
        if (JSON.stringify(specInfo) === strObj) {
          console.log(0);
          if (this.showPrice) {
            this.searchLists[index].price = value.marketPrice;
          } else {
            this.searchLists[index].price = "";
          }
          this.searchLists[index].maxNum = value.saleNum;
          this.searchLists[index].skuId = value.id;
          this.searchLists[index].num = 1;
        }
      });
    },
    // 搜索值
    sValue(data) {
      this.brandIds = null;
      this.brandValue = "";
      this.categoryId = null;
      this.searchValue = data;
      this.parameterValue = [];
      this.page = 1;
      this.defaultValue = "synthesize";
      this.manner = 0;
      this.salesVolumeStatus = 1;
      this.priceStatus = 1;
      this.changeQuery();
      // this.getSearchValue();
    },
    // 商品分类搜索
    sId(data) {
      this.brandIds = null;
      this.searchValue = null;
      this.parameterValue = [];
      this.categoryId = data[0];
      this.classifyValue = data[1];
      this.page = 1;
      this.defaultValue = "synthesize";
      this.manner = 0;
      this.salesVolumeStatus = 1;
      this.priceStatus = 1;
      this.changeQuery();
      // this.getSearchValue();
    },
    // 品牌点击更多
    more() {
      this.moreBrand = !this.moreBrand;
      this.multi = false;
      this.checkList = [];
      this.parameterMultiSelectId = "";
      this.parameterMoreId = "";
    },
    // 品牌点击多选
    multiSelect() {
      this.multi = !this.multi;
      this.parameterMultiSelectId = "";
      this.parameterMoreId = "";
      this.moreBrand = false;
    },
    // 点击品牌
    clickOnBrand(value) {
      if (this.multi) {
        if (this.checkList.indexOf(value) === -1) {
          this.checkList.push(value);
        } else {
          let index = this.checkList.indexOf(value);
          this.checkList.splice(index, 1);
        }
      } else {
        // this.searchValue = null;
        // this.categoryId = null;
        this.brandValue = value.name;
        this.brandIds = value.id;
        this.page = 1;
        this.defaultValue = "synthesize";
        this.manner = 0;
        this.salesVolumeStatus = 1;
        this.priceStatus = 1;
        this.changeQuery();
        // this.getSearchValue();
      }
    },
    // 多选确定按钮
    searchBrandBymulti() {
      let strIds = "";
      let strName = "";
      this.checkList.map((value) => {
        strIds += value.id + "-";
        strName += value.name + "、";
      });
      // this.categoryId = null;
      // this.searchValue = null;
      this.brandValue = strName.slice(0, strName.length - 1);
      this.brandIds = strIds.slice(0, strIds.length - 1);
      this.page = 1;
      this.defaultValue = "synthesize";
      this.manner = 0;
      this.salesVolumeStatus = 1;
      this.priceStatus = 1;
      this.changeQuery();
      // this.getSearchValue();
      this.closeMulti();
    },
    // 取消多选
    closeMulti() {
      this.multi = !this.multi;
      this.checkList = [];
    },
    // 关闭搜索值
    resetSearch(num) {
      this.moreBrand = false;
      this.multi = false;
      this.checkList = [];
      this.page = 1;
      this.defaultValue = "synthesize";
      this.manner = 0;
      this.salesVolumeStatus = 1;
      this.priceStatus = 1;
      if (num === 0) {
        this.classifyValue = "";
        this.categoryId = null;
      } else if (num === 1) {
        this.searchValue = "";
      } else {
        this.brandIds = null;
        this.brandValue = "";
      }
      this.changeQuery();
      // this.getSearchValue();
    },
    //点击参数的更多
    parameterMore(id) {
      this.moreBrand = false;
      this.multi = false;
      this.parameterMultiSelectId = "";
      if (this.parameterMoreId === id) {
        this.parameterMoreId = "";
      } else {
        this.parameterMoreId = id;
      }
    },
    //点击参数的多选
    parameterMultiSelect(id, name) {
      this.moreBrand = false;
      this.multi = false;
      if (this.parameterMultiSelectId === id) {
        this.parameterMultiSelectId = "";
      } else {
        this.parameterMultiSelectId = id;
        this.parameterMultiSelectName = name;
        this.parameterMoreId = id;
      }
    },
    //参数多选确定
    searchParameterBymulti() {
      let strName = "";
      this.parameterCheckList.map((value) => {
        strName += value.value + "、";
      });
      let obj = {};
      obj.id = this.parameterMultiSelectId;
      obj.name = this.parameterMultiSelectName;
      obj.childrenVal = strName.slice(0, strName.length - 1);
      obj.children = JSON.parse(JSON.stringify(this.parameterCheckList));
      obj.more = true;
      this.parameterValue.push(obj);
      this.changeQuery();
      // this.getSearchValue();
      this.closeParameterMulti();
    },
    //参数多选取消
    closeParameterMulti() {
      this.parameterMultiSelectId = "";
      this.parameterMultiSelectName = "";
      this.parameterMoreId = "";
      this.parameterCheckList = [];
    },
    // 点击参数
    clickOnParameter(id, name, v) {
      if (this.parameterMultiSelectId === id) {
        if (this.parameterCheckList.indexOf(v) === -1) {
          this.parameterCheckList.push(v);
        } else {
          let index = this.parameterCheckList.indexOf(v);
          this.parameterCheckList.splice(index, 1);
        }
      } else {
        this.parameterCheckList = [];
        let obj = {};
        obj.id = id;
        obj.name = name;
        obj.childrenVal = v.value;
        obj.children = [];
        obj.children.push(v);
        this.parameterValue.push(obj);
        this.changeQuery();
        // this.getSearchValue();
      }
    },
    //关闭参数
    closeParameter(index) {
      // this.parameterIds = "";
      this.parameterValue.splice(index, 1);
      this.changeQuery();
      // this.getSearchValue();
    },
    //修改地址栏query
    changeQuery() {
      let path = this.$router.history.current.path;
      let query = this.$router.history.current.query;
      let newQuery = JSON.parse(JSON.stringify(query));
      newQuery.value = this.searchValue;
      newQuery.categoryId = this.categoryId;
      newQuery.classifyValue = this.classifyValue;
      newQuery.brandIds = this.brandIds;
      newQuery.brandValue = this.brandValue;
      newQuery.parameterValue = JSON.stringify(this.parameterValue);
      this.$router.push({
        path,
        query: newQuery,
      });
    },
    // 切换模块
    changeRange(num) {
      this.manner = num;
    },
    // 前往详情页
    goToProduct(id) {
      let routeUrl = this.$router.resolve({
        path: "/product",
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 加入购物车
    inCart(value, index) {
      if (this.token) {
        let data = {
          goodsId: value.id,
        };
        xbShoppingCart.postAddShoppingCart(data).then((res) => {
          // this.searchLists[index].addCartShow = false;
          if (res.success) {
            if (index >= 0) {
              if (!this.searchLists[index].addCartShow) {
                let addCart = document.querySelector(".addCart" + index);
                let imgFade = document.querySelector(
                  ".img-fade-container" + index
                );
                let left = addCart.getBoundingClientRect().left;
                let top = addCart.getBoundingClientRect().top;
                imgFade.style.right = null;
                imgFade.style.position = "fixed";
                imgFade.style.left = left + "px";
                imgFade.style.top = top + "px";
                this.searchLists[index].addCartShow = true;
                setTimeout(() => {
                  this.searchLists[index].addCartShow = false;
                  this.carDate = new Date().getTime();
                }, 1000);
              } else {
                this.carDate = new Date().getTime();
              }
            } else {
              this.carDate = new Date().getTime();
            }
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.seletGoods(value)
      }
    },
    seletGoods(value) {
      this.selectCartGoods = getXbTouristCartGoods()
      let obj = {}
      obj.goodsId = value.id
      obj.name = value.name
      obj.img = value.img
      obj.number = 1
      const findItem = value.items.find(item => item.saleNum > 0)
      obj.skuId = findItem.id
      obj.title = findItem.specInfo
      obj.price = findItem.marketPrice
      obj.saleNum = findItem.saleNum
      this.selectCartGoods.push(obj)
      saveXbTouristCartGoods(this.selectCartGoods)
      eventVue.$emit('uplodeCartGoods')
    },
    //加入选品池
    inSelectionCart(id) {
      let data = {
        goodsId: id,
      };
      xbSelectionCart.postXBAddSelection(data).then((res) => {
        if (res.success) {
          this.selectionDate = new Date().getTime();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 加入购物车带数量
    inCartNumber(index) {
      let goodsId = this.searchLists[index].id;
      let itemId = this.searchLists[index].skuId;
      let quantity = this.searchLists[index].num;
      let data = {
        goodsId,
        itemId,
        quantity,
      };
      xbShoppingCart.postAddShoppingCart(data).then((res) => {
        if (res.success) {
          if (index >= 0) {
            if (!this.searchLists[index].addCartShow) {
              let addCart = document.querySelector(".addCart" + index);
              let imgFade = document.querySelector(
                ".img-fade-container" + index
              );
              let left = addCart.getBoundingClientRect().left;
              let top = addCart.getBoundingClientRect().top;
              imgFade.style.right = null;
              imgFade.style.position = "fixed";
              imgFade.style.left = left + "px";
              imgFade.style.top = top + "px";
              this.searchLists[index].addCartShow = true;
              setTimeout(() => {
                this.searchLists[index].addCartShow = false;
                this.carDate = new Date().getTime();
              }, 1000);
            } else {
              this.carDate = new Date().getTime();
            }
          } else {
            this.carDate = new Date().getTime();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 加入收藏夹
    inCollection(id, status, index) {
      if (status === 0) {
        xbProduct.getXBAddCollection(id).then((res) => {
          if (res.success) {
            this.commodityDate = new Date().getTime();
            this.searchLists[index].collectionStatus = 1;
            this.$message.success("收藏成功！");
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        xbProduct.getXBCancelCollection(id).then((res) => {
          if (res.success) {
            this.commodityDate = new Date().getTime();
            this.searchLists[index].collectionStatus = 0;
            this.$message.success("取消收藏！");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 跳转页码
    updatePage(data) {
      this.page = data.currentPage;
      window.scrollTo(0, 0);
      this.getSearchValue();
    },
    beforeEnter: function (el) {
      console.log(el);
      // ...
    },
    // 当与 CSS 结合使用时
    // 回调函数 done 是可选的
    enter: function (el, done) {
      el.style.left = null;
      if (this.slide) {
        Velocity(el, { right: "310px", top: "250px" }, { duration: 800 });
      } else {
        Velocity(el, { right: "0px", top: "250px" }, { duration: 800 });
      }

      done();
    },
    afterEnter: function (el) {
      // console.log(el);
      // ...
    },
    enterCancelled: function (el) {
      // console.log(el);
      // ...
    },
    slideStatus(data) {
      this.slide = data;
    },
    //选择分类
    selectClassify(id, name) {
      this.classifyValue = name;
      this.categoryId = id;
      this.brandIds = null;
      this.brandValue = "";
      this.searchValue = "";
      this.parameterValue = [];
      this.changeQuery();
    },
    openClassify(type, index) {
      if (type === 1) {
        if (this.openIndex[0] === index) {
          this.openIndex = [];
        } else {
          this.openIndex = [];
          this.openIndex.push(index);
        }
      } else {
        if (this.openIndex[1] === index) {
          this.openIndex.splice(1, 1);
        } else {
          // let arr = [];
          // arr.push()
          this.openIndex.splice(1, 1, index);
        }
      }
      console.log(this.openIndex);
    },
    //获取商品池状态
    getModuleSelection() {
      if (getXBBasicInformation() !== "") {
        this.isModuleSelection =
          getXBBasicInformation().moduleSelection === 1 ? true : false;
      } else {
        setTimeout(() => {
          this.getModuleSelection();
        }, 1000);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.search-container {
  background: #fff;
  .search-container {
    width: 1200px;
    margin: 0 auto;
  }
  .menu {
    border-bottom: 2px solid #df3445;
    .menu-container {
      width: 1200px;
      margin: 0 auto;
    }
  }
  .main-container {
    width: 1200px;
    margin: 0 auto;
    .search-result {
      min-height: 40px;
      width: 1200px;
      display: flex;
      /* align-items: center; */
      font-size: 14px;
      color: #919398;
      .all-title {
        display: block;
        line-height: 40px;
        font-size: 12px;
        height: 40px;
        width: 75px;
      }
      .display-area {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        min-height: 32px;
        padding-bottom: 8px;
      }
      .showValue {
        display: flex;
        align-items: center;
        padding-top: 8px;
        margin: 0;
      }
      .showValueSpan {
        .w280 {
          display: inline-block;
          max-width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
        }
      }
      .closed {
        font-size: 12px;
        height: 24px;
        box-sizing: border-box;
        margin: 8px 8px 0px 0;
        padding: 5px;
        border: 1px solid #e4e4e4;
        display: inline-block;
        display: flex;
        align-items: center;
        svg {
          margin-left: 10px;
        }
        svg:hover {
          cursor: pointer;
          path {
            fill: #df3445;
          }
        }
      }
      .margin0 {
        margin-right: 0;
      }
      .parameterValue {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .w280 {
          display: inline-block;
          max-width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
        }
        .closed {
          margin-right: 10px;
        }
      }
    }
    .classify-parameter-recommend-product {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .classify-recommend {
        width: 180px;
        .classify-container {
          width: 180px;
          background: rgba(238, 238, 238, 1);
          border: 1px solid rgba(228, 228, 228, 1);
          box-sizing: border-box;
          margin-bottom: 20px;
          color: #333333;
          font-size: 12px;
          .all-classify {
            height: 34px;
            padding-left: 12px;
            line-height: 34px;
            cursor: pointer;
          }
          .all-classify:hover {
            color: #df3445;
          }
          .first-classify {
            border-top: 1px solid #e4e4e4;
            height: 34px;
            padding-left: 12px;
            padding-right: 12px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
          }
          .second-classify-container {
            background: rgba(247, 247, 247, 1);
            display: none;
            .second-classify {
              height: 34px;
              padding-left: 20px;
              padding-right: 12px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              cursor: pointer;
            }
            .third-classify-container {
              font-size: 12px;
              background: #ffffff;
              display: flex;
              flex-wrap: wrap;
              display: none;
              .third-classify {
                width: 89px;
                height: 34px;
                line-height: 34px;
                padding-left: 20px;
                padding-right: 10px;
                box-sizing: border-box;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
              }
              .third-classify:hover {
                color: #df3445;
              }
            }
            .third-classify-open {
              display: block;
              display: flex;
            }
          }
          .classify-name:hover {
            color: #df3445;
          }
          .active-classify-name {
            color: #df3445;
          }
          .second-classify-open {
            display: block;
          }
        }
        .recommend {
          width: 180px;
          .title {
            height: 40px;
            background: #f7f7f7;
            font-size: 14px;
            font-weight: 400;
            color: rgba(96, 98, 102, 1);
            line-height: 40px;
            letter-spacing: 2px;
            padding-left: 10px;
            border: 1px solid #e4e4e4;
            border-bottom: 0;
          }
          .recommend-list {
            li {
              height: 230px;
              border: 1px solid #e4e4e4;
              border-top: 0;
              box-sizing: border-box;
              padding-top: 12px;
              display: flex;
              flex-direction: column;
              align-items: center;
              .img {
                width: 140px;
                height: 140px;
                box-sizing: border-box;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  max-width: 140px;
                  max-height: 140px;
                  cursor: pointer;
                }
              }
              .name {
                font-size: 14px;
                font-weight: 500;
                color: rgba(96, 98, 102, 1);
                line-height: 20px;
                letter-spacing: 1px;
                width: 156px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                letter-spacing: 1px;
                margin-bottom: 5px;
                font-size: 12px;
              }
              .name:hover {
                cursor: pointer;
                color: rgba(223, 52, 69, 1);
              }
              .price {
                width: 156px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(223, 52, 69, 1);
                line-height: 20px;
                letter-spacing: 1px;
              }
            }
          }
        }
      }
    }
    .collapse-parameter {
      width: 1000px;
      border-top: 1px solid #e4e4e4;
      margin-bottom: 20px;
      .collapse-container {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #e4e4e4;
        .collapse {
          display: flex;
          align-items: flex-start;
          flex: 1;
          background: #f7f7f7;
          .collapse-title {
            padding-left: 20px;
            width: 100px;
            line-height: 36px;
            font-size: 12px;
          }
          .collapse-content {
            background: white;
            flex: 1;
            font-size: 12px;
            .list {
              width: 740px;
              padding: 0 20px;
              height: 36px;
              overflow: hidden;
              display: flex;
              flex-wrap: wrap;
              li {
                display: inline-block;
                width: 130px;
                height: 36px;
                box-sizing: border-box;
                word-break: break-all;
                padding-right: 5px;
                line-height: 36px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
              }
              li:hover {
                cursor: pointer;
                color: #df3445;
              }
              .red {
                color: #df3445;
              }
            }
            .h160 {
              height: auto;
              max-height: 216px;
              overflow: auto;
            }
            .close {
              display: none;
            }
            .open {
              border-top: 1px solid rgba(238, 238, 238, 1);
              .check {
                padding: 16px;
                display: flex;
                .describe {
                  font-size: 12px;
                  min-width: 80px;
                  line-height: 16px;
                }
              }
              .none {
                display: none;
              }
              .button {
                height: 64px;
                display: flex;
                justify-content: center;
                align-items: center;
                .el-button {
                  background: rgba(238, 238, 238, 1);
                  border: 1px solid rgba(229, 229, 229, 1);
                  border-radius: 2px;
                  color: rgba(102, 102, 102, 1);
                  font-size: 12px;
                }
                .opacity {
                  opacity: 0.5;
                }
                .red {
                  background: #df3445;
                  border: 1px solid #df3445;
                  color: #fff;
                }
              }
            }
          }
        }
        .collapse-more {
          width: 100px;
          height: 36px;
          font-size: 12px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          p {
            margin-left: 5px;
            line-height: 24px;
            padding: 0 3px;
            border: 1px solid rgba(229, 229, 229, 1);
            cursor: pointer;
          }
        }
        .collapse-none {
          display: none;
        }
      }
      .border {
        border: 1px solid #df3445;
        box-sizing: border-box;
      }
      .parameter-container {
        .parameter {
          width: 1000px;
          background: #f7f7f7;
          display: flex;
          font-size: 12px;
          border-bottom: 1px solid #e4e4e4;
          .parameter-title {
            line-height: 36px;
            min-width: 120px;
            padding-left: 20px;
            box-sizing: border-box;
          }
          .parameter-content {
            flex: 1;
            background: #fff;
            display: flex;
            .parameter-select {
              .parameter-list {
                height: 36px;
                overflow: hidden;
                width: 740px;
                padding: 0 20px;
                display: flex;
                flex-wrap: wrap;
                .parameter-li {
                  width: 130px;
                  line-height: 36px;
                }
                .parameter-li:hover {
                  cursor: pointer;
                  color: #df3445;
                }
                .red {
                  color: #df3445;
                }
              }
              .parameter-list-more {
                height: auto;
                max-height: 216px;
                overflow: auto;
              }
              .select {
                width: 878px;
                border-top: 1px solid #eeeeee;
                .check {
                  padding: 16px;
                  display: flex;
                  .describe {
                    font-size: 12px;
                    min-width: 80px;
                    line-height: 16px;
                  }
                }
                .none {
                  display: none;
                }
                .button {
                  height: 64px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .el-button {
                    background: rgba(238, 238, 238, 1);
                    border: 1px solid rgba(229, 229, 229, 1);
                    border-radius: 2px;
                    color: rgba(102, 102, 102, 1);
                    font-size: 12px;
                  }
                  .opacity {
                    opacity: 0.5;
                  }
                  .red {
                    background: #df3445;
                    border: 1px solid #df3445;
                    color: #fff;
                  }
                }
              }
              .close {
                display: none;
              }
            }
            .parameter-operation {
              width: 100px;
              height: 36px;
              font-size: 12px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              p {
                margin-left: 5px;
                line-height: 24px;
                padding: 0 3px;
                border: 1px solid rgba(229, 229, 229, 1);
                cursor: pointer;
              }
            }
          }
        }
        .border {
          border: 1px solid #df3445;
          box-sizing: border-box;
        }
      }
      .isOpen {
        font-size: 12px;
        display: flex;
        line-height: 24px;
        justify-content: center;
        cursor: pointer;
        p {
          width: 64px;
          height: 24px;
          border: 1px solid rgba(229, 229, 229, 1);
          position: relative;
          top: -1px;
          background: #fff;
          text-align: center;
          border-top: 0;
        }
      }
    }
    .recommend-product-list {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      .product-list {
        width: 1000px;
        .title {
          height: 40px;
          background: #f7f7f7;
          color: rgba(96, 98, 102, 1);
          display: flex;
          align-items: center;
          justify-content: space-between;
          .title-left-list {
            display: flex;
            .title-left-list-li {
              width: 80px;
              height: 40px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              cursor: pointer;
              .svg {
                display: flex;
                height: 20px;
                width: 20px;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                .top {
                  path {
                    fill: #df3445;
                  }
                }
                .bottom {
                  path {
                    fill: #df3445;
                  }
                }
              }
            }
            .borderBottom {
              padding-top: 4px;
              border-bottom: 4px solid #df3445;
              color: #df3445;
            }
          }
          .title-right {
            display: flex;
            height: 40px;
            justify-content: center;
            align-items: center;
            .deliver {
              position: relative;
              width: 88px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              margin-right: 12px;
              .deliver-tit {
                display: inline-block;
                width: 70px;
                height: 40px;
                margin-right: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              span {
                font-size: 12px;
                font-weight: 400;
                color: #606266;
              }
              .deliverImg {
                position: absolute;
                top: 50%;
                right: 0px;
                transform: translate(-50%, 0);
                width: 8px;
                height: 6px;
              }
            }
            .deliver:hover {
              background: #ffffff;
              border: 1px solid #eeeeee;
              cursor: pointer;
              .deliver-address {
                display: block;
              }
            }
            .manner {
              width: 20px;
              height: 20px;
              margin-right: 12px;
              cursor: pointer;
            }
            .manner.actived {
              background: red;
            }
          }
          .deliver-address {
            display: none;
            position: absolute;
            top: 40px;
            right: 0px;
            width: 362px;
            height: 320px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            box-shadow: 1px 6px 5px 0px rgba(0, 0, 0, 0.08);
            border-radius: 0px 0px 6px 6px;
            z-index: 10;
            padding: 17px 20px 17px 20px;
            .deliver-title {
              height: 56px;
              border-bottom: 1px dashed #eeeeee;
              .deliver-title-address {
                text-align: left;
                line-height: 14px;
                font-size: 14px;
                font-weight: 400;
                color: #606266;
                margin-bottom: 12px;
              }
              .deliver-title-content {
                text-align: left;
                line-height: 14px;
                font-size: 14px;
                font-weight: 400;
                span {
                  color: #bcbcbc;
                  width: 14px;
                  height: 14px;
                }
                img {
                  width: 14px;
                  height: 14px;
                  margin-left: 0px;
                  margin-right: 6px;
                }
              }
              .btn {
                display: flex;
                justify-content: flex-start;
                width: 72px;
                height: 24px;
                border-radius: 4px;
                padding: 12px 10px;
                font-size: 12px;
                font-weight: 400;
                color: #fff;
                background: #df3445;
              }
              .detailedAddress {
                display: flex;
                justify-content: flex-start;
                line-height: 14px;
                margin-top: 8px;
                font-size: 14px;
                font-weight: 400;
                color: #606266;
              }
            }
            .deliver-address-content {
              div {
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;
                padding-top: 15px;
                span {
                  text-align: left;
                  width: 72px;
                  box-sizing: border-box;
                  padding: 4px;
                  line-height: 14px;
                  font-size: 14px;
                  font-weight: 400;
                  color: #606266;
                  margin-bottom: 15px;
                  cursor: pointer;
                }
                .active {
                  color: #df3445;
                }
              }
            }
          }
        }
        .content-container {
          .labels {
            width: 180px;
            height: 16px;
            margin-bottom: 4px;
            font-size: 12px;
            display: flex;
            .promotionLabel {
              width: 30px;
              height: 16px;
              background: rgba(223, 52, 69, 1);
              border-radius: 2px;
              color: #fff;
              line-height: 16px;
              text-align: center;
              margin-right: 4px;
            }
            .collectionLabel {
              width: 30px;
              height: 16px;
              border: 1px solid rgba(61, 116, 242, 1);
              border-radius: 2px;
              color: rgba(61, 116, 242, 1);
              box-sizing: border-box;
              line-height: 14px;
              text-align: center;
              margin-right: 4px;
            }
            .label {
              flex: 1;
              overflow: hidden;
              white-space: nowrap;
              height: 16px;
              border-radius: 2px;
              line-height: 16px;
            }
            .labelName {
              width: 60px;
              padding: 0 3px;
              text-align: center;
              display: inline-block;
              background: rgba(223, 52, 69, 0.1);
              color: #df3445;
              margin-right: 3px;
              .none {
                display: none;
              }
            }
            .backWhite {
              padding: 0px;
              background: #fff;
              color: #666;
            }
          }
          .lump {
            padding-top: 10px;
            min-height: 600px;
            .list {
              display: flex;
              flex-wrap: wrap;
              width: 1000px;
              li {
                width: 200px;
                height: 294px;
                margin-bottom: 10px;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-right: 0px;
                .img {
                  width: 140px;
                  height: 140px;
                  padding: 10px;
                  margin-bottom: 5px;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
                .tit {
                  width: 180px;
                  height: 40px;
                  box-sizing: border-box;
                  padding-left: 4px;
                  font-size: 12px;
                  color: rgba(96, 98, 102, 1);
                  line-height: 20px;
                  margin-bottom: 5px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  // white-space: pre-wrap;
                  cursor: pointer;
                }
                .tit:hover {
                  color: rgba(223, 52, 69, 1);
                }
                .price {
                  width: 180px;
                  height: 22px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 6px;
                  font-size: 20px;
                  line-height: 20px;
                  .price-container {
                    .new-price {
                      color: rgba(223, 52, 69, 1);
                    }
                    .old-price {
                      text-decoration: line-through;
                      font-size: 14px;
                      margin-left: 12px;
                    }
                  }
                  .no-price {
                    font-size: 14px;
                    padding-left: 4px;
                    color: rgba(223, 52, 69, 1);
                    line-height: 20px;
                  }
                  .visiable {
                    visibility: hidden;
                  }
                  .label {
                    padding: 0 2px;
                    font-size: 12px;
                    color: #fff;
                    background: rgba(223, 52, 69, 1);
                    line-height: 12px;
                    text-align: center;
                  }
                  .commission-rate {
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                  }
                }
                .button {
                  display: flex;
                  height: 24px;
                  width: 180px;
                  /* position: relative; */
                  .el-button {
                    height: 24px;
                    padding: 0px;
                    line-height: 24px;
                    border: 0;
                    font-size: 14px;
                    border-radius: 2px;
                  }
                  .addCart {
                    width: 100px;
                    background: rgba(223, 52, 69, 0.75);
                    color: #fff;
                  }
                  .addCart:hover {
                    background: rgba(223, 52, 69, 1);
                  }
                  .gray:hover {
                    background: rgba(145, 147, 152, 1);
                  }
                  .gray {
                    width: 110px;
                    color: #fff;
                    background: rgba(145, 147, 152, 1);
                  }
                  .addCollection {
                    width: 70px;
                    border: 1px solid rgba(238, 238, 238, 1);
                    background: #fff;
                    color: #999999;
                  }
                  .img-fade-container {
                    /* position: absolute; */
                    z-index: 99;
                  }
                  /* .img-fade-enter-active {
                    transition: all 1s ease-out;
                  }
                  .img-fade-enter-to {
                    transform: translate(500px, -500px);
                  } */
                }
                .isSelect {
                  .el-button {
                    margin: 0;
                    font-size: 12px;
                    border-radius: 0;
                  }
                  .addCart {
                    background: #fff;
                    color: #df3445;
                    border: 1px solid rgba(238, 238, 238, 1);
                  }
                  .addCart:hover {
                    color: #fff;
                    background: rgba(223, 52, 69, 1);
                  }
                  .addCollection {
                    border-left: 0;
                  }
                }
              }
              li:hover {
                box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.14);
              }
            }
          }
          .two-block {
            padding: 20px 0;
            min-height: 600px;
            .list {
              li {
                display: flex;
                align-items: center;
                padding: 10px 20px 10px 20px;
                border: 1px solid rgba(219, 223, 230, 1);
                justify-content: space-between;
                border-bottom: 0;
                .img {
                  width: 80px;
                  height: 80px;
                  padding: 6px;
                  box-sizing: border-box;
                  margin-right: 40px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                }
                .content-right {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .tit-specifications {
                    .tit {
                      height: 16px;
                      width: 450px;
                      box-sizing: border-box;
                      padding-left: 4px;
                      font-size: 12px;
                      color: rgba(96, 98, 102, 1);
                      line-height: 16px;
                      margin-bottom: 12px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 1;
                      letter-spacing: 1px;
                      white-space: pre-wrap;
                    }
                    .tit-link:hover {
                      cursor: pointer;
                      color: rgba(223, 52, 69, 1);
                    }
                    .specifications {
                      display: flex;
                      align-items: center;
                      flex-wrap: wrap;
                      width: 560px;
                      .specifications-child {
                        margin-right: 20px;
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        .specifications-child-title {
                          font-size: 12px;
                          line-height: 20px;
                          white-space: nowrap;
                        }
                      }
                    }
                  }
                  .content-number-store-price-cart {
                    display: flex;
                    .number-store {
                      width: 100px;
                      height: 80px;
                      margin-right: 60px;
                      box-sizing: border-box;
                      padding-top: 20px;
                      display: flex;
                      align-items: center;
                      flex-direction: column;
                      .store {
                        padding-top: 5px;
                        font-size: 12px;
                      }
                    }
                  }
                  .price-cart {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    .price {
                      font-size: 20px;
                      color: rgba(223, 52, 69, 1);
                      line-height: 28px;
                      margin-bottom: 10px;
                    }
                    .no-price {
                      font-size: 14px;
                      padding-left: 4px;
                      color: rgba(223, 52, 69, 1);
                      line-height: 20px;
                      margin-bottom: 10px;
                    }
                    .el-button {
                      width: 100px;
                      height: 24px;
                      background: rgba(223, 52, 69, 0.75);
                      border-radius: 2px;
                      border: 0;
                      color: #fff;
                      padding: 0;
                    }
                    .nothing {
                      background: #919398;
                      border-radius: 2px;
                      border: 2px solid #919398;
                      line-height: 0px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    }
                    .el-button:hover {
                      background: rgba(223, 52, 69, 1);
                    }
                    .nothing:hover {
                      background: #919398;
                      border-radius: 2px;
                      border: 2px solid #919398;
                    }
                  }
                }
              }
              li:last-child {
                border-bottom: 1px solid rgba(219, 223, 230, 1);
              }
              li:hover {
                padding: 10px 20px 9px 20px;
                border: 1px solid rgba(223, 52, 69, 1);
              }
            }
          }
          .tabulation {
            padding: 20px;
            min-height: 600px;
            .list {
              display: flex;
              flex-wrap: wrap;
              justify-content: space-between;
              width: 970px;
              li {
                width: 475px;
                display: flex;
                flex-direction: column;
                height: 80px;
                box-sizing: border-box;
                border: 1px solid rgba(219, 223, 230, 1);
                padding: 5px 20px;
                margin: 0 10px 10px 0;
                .tit {
                  height: 16px;
                  width: 420px;
                  box-sizing: border-box;
                  padding-left: 4px;
                  font-size: 12px;
                  color: rgba(96, 98, 102, 1);
                  line-height: 18px;
                  margin-bottom: 5px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                  white-space: pre-wrap;
                  letter-spacing: 1px;
                  .tit-link:hover {
                    cursor: pointer;
                    color: rgba(223, 52, 69, 1);
                  }
                }
                .labels {
                  margin-bottom: 0;
                }
                .price-car {
                  height: 28px;
                  width: 420px;
                  display: flex;
                  align-items: flex-end;
                  justify-content: space-between;
                  .price {
                    width: 103px;
                    font-size: 20px;
                    color: rgba(223, 52, 69, 1);
                    line-height: 28px;
                  }
                  .no-price {
                    font-size: 14px;
                    padding-left: 4px;
                    color: rgba(223, 52, 69, 1);
                    line-height: 20px;
                  }
                  .el-button {
                    width: 80px;
                    height: 24px;
                    background: rgba(223, 52, 69, 0.75);
                    border-radius: 2px;
                    border: 0;
                    color: #fff;
                    padding: 0;
                    font-size: 12px;
                  }
                  .nothing {
                    background: #919398;
                    border-radius: 2px;
                    border: 2px solid #919398;
                  }
                  .el-button:hover {
                    background: rgba(223, 52, 69, 1);
                  }
                  .nothing:hover {
                    background: #919398;
                    border-radius: 2px;
                    border: 2px solid #919398;
                  }
                }
              }
              li:hover {
                border: 1px solid rgba(223, 52, 69, 1);
              }
            }
          }
          .pagination {
            height: 40px;
            border-top: 1px solid #f7f7f7;
            border-bottom: 1px solid #f7f7f7;
            display: flex;
            justify-content: center;
            align-items: center;
            .el-pagination {
              .el-icon {
                font-size: 14px;
              }
              .el-pager {
                .number {
                  font-size: 14px;
                }
              }
            }
          }
        }
        .nothing {
          height: 600px;
          padding-top: 133px;
          display: flex;
          justify-content: center;
          img {
            width: 184px;
            height: 209px;
          }
        }
        .nothingNum {
          display: flex;
          justify-content: center;
          height: 600px;
          padding-top: 133px;
          img {
            width: 184px;
            height: 243px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.search-container {
  .el-select {
    width: 100px;
    .el-input__inner {
      height: 24px;
      background: rgba(234, 238, 245, 0.2);
      border-radius: 4px;
      border: 1px solid rgba(234, 238, 245, 1);
      padding: 0 20px 0 8px;
      font-size: 12px;
      font-family: "PingFangSC-Regular";
      color: rgba(96, 98, 102, 1);
      letter-spacing: 1px;
      padding-left: 15px;
    }
    .el-input__suffix {
      height: 40px;
      top: -7px;
      right: 0px;
    }
    .is-focus {
      .el-input__inner {
        border: 1px solid rgba(61, 116, 242, 1);
      }
    }
  }
  .number-store {
    .el-input-number {
      width: 80px;
      line-height: 24px;
      .el-input-number__decrease {
        height: 22px;
        width: 22px;
        top: 2px;
      }
      .el-input-number__increase {
        height: 22px;
        width: 22px;
        top: 2px;
      }
      .el-input__inner {
        height: 24px;
        line-height: 24px;
        padding-left: 22px;
        padding-right: 22px;
      }
    }
  }
  .check {
    .el-checkbox-group {
      .el-checkbox {
        .is-checked {
          .el-checkbox__inner {
            background-color: #df3445;
            border-color: #df3445;
          }
        }
        .el-checkbox__label {
          font-size: 12px;
          color: #606266;
        }
      }
    }
  }
  .addCollection {
    display: flex;
    align-items: center;
    justify-content: center;
    > span {
      height: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        margin-right: 5px;
      }
    }
  }
  .deliver-address {
    .el-breadcrumb__inner {
      font-size: 14px;
      font-weight: 400;
      color: #606266;
    }
    .activeTitle {
      width: 70px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      .el-breadcrumb__inner {
        font-weight: bold;
        color: #343434;
      }
    }
  }
}
</style>
